import { Component, EventEmitter, OnInit } from '@angular/core';
import { CrossStudyService } from './cross-study.service';
import { Title } from '@angular/platform-browser';
import { SideNavbarService } from '../side-navbar/side-navbar.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from '../shared/globals';
import { catchError, combineLatest, flatMap, map, mergeMap, Observable, Subscription } from 'rxjs';
import { TextService } from '../shared/text.service';
import { environment } from '../../environments/environment';
//import { MaterialModule } from "../shared/material/material.module";

@Component({
  selector: 'app-cross-study',
  templateUrl: './cross-study.component.html',
  styleUrls: ['./cross-study.component.css']
  //imports: [MaterialModule]
})
export class CrossStudyComponent implements OnInit {


  organisations: any[] = [];
  networks: any[] = [];
  courses: any[] = [];
  selectedOrganisation: string = '';
  id:any;
  header: any;
  select:any;
  description: any;
  code: any;
  name: any;
  isLoaded = false;
  isOrganisationsLoaded = false;
  errorMessage: any;
  actions: EventEmitter<any|any> = new EventEmitter <any|any>();
  period: any;
  // subscriptions
  private subscription: Subscription = new Subscription();
  sortedOrganisations: any;
  educationType: any;

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private textService: TextService,
    private navigationService: SideNavbarService,
    private titleService: Title,
    private service: CrossStudyService
  ) { }

  ngOnInit(): void {
    this.subscription.add(this.textService.getText('search.result.code').subscribe(
      value => this.code = value,
      error => this.errorMessage = <any>error
    ));

    this.subscription.add(this.textService.getText('search.result.name').subscribe(
      value => this.name = value,
      error => this.errorMessage = <any>error
    ));

    this.subscription.add(this.textService.getText('cross.study.header').subscribe(
      value => this.header = value,
      error => this.errorMessage = <any>error
    ));

    this.subscription.add(this.textService.getText('cross.study.select').subscribe(
      value => this.select = value,
      error => this.errorMessage = <any>error
    ));

    this.subscription.add(this.textService.getText('search.result.code').subscribe(
      value => this.code = value,
      error => this.errorMessage = <any>error
    ));

    this.subscription.add(this.textService.getText('search.result.name').subscribe(
      value => this.name = value,
      error => this.errorMessage = <any>error
    ));

    //this.subscription.add(this.getOrganisations());
    //this.subscription.add(this.getNetworks('0'));

    // tällä alustetaan kielivalinta sovellukselle urlista
    this.subscription.add(this.route.params.subscribe(params => {
      if (params['lang'] === 'fi') {
        this.globals.lang = 'fi'
      }
      if (params['lang'] === 'en') {
        this.globals.lang = 'en'
      }
      if (params['lang'] === 'sv') {
        this.globals.lang = 'sv'
      }
    }));

    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        id: params[0].get('id'), 
        period: params[1].get('period')
      })),
      mergeMap(params => {
        this.id= params.id;
        this.period = params.period;
        this.isLoaded = true;
        return this.service.getOrganisations();
      }),
      mergeMap(organisations => {
          this.organisations = organisations;
          //this.sortedOrganisations = this.globals.sortMapValuesByName(this.organisations, this.globals.lang);
          //console.log(Object.values(this.sortedOrganisations).map((x: any) => x.valueFi));
          // (usually in ngOnInit after loading the data)
          this.sortedOrganisations = Object.entries(this.organisations)
            .map(([key, value]) => ({ key, value }))
            .sort((a, b) =>
              (a.value.valueFi ?? '').localeCompare(b.value.valueFi ?? '', 'fi', { sensitivity: 'base' })
            );

          // If you always want key "0" on top, move it to first place:
          const idx = this.sortedOrganisations.findIndex((org: { key: string, value: any }) => org.key === '0');
          if (idx > 0) {
            const [zeroOrg] = this.sortedOrganisations.splice(idx, 1);
            this.sortedOrganisations.unshift(zeroOrg);
          }

          return this.service.getCrossStudyNetworks('0');
      }),
      mergeMap(networks => {
        this.networks = networks;  
        this.globals.sortByName2(this.networks, this.globals.lang);
        this.networks.forEach(network => {
          this.globals.sortByName2(network.courses, this.globals.lang);
        });
        return this.navigationService.getNavigationItem(this.id);
      })
    
    ).subscribe(navigationItem => {
        this.educationType = navigationItem;
        this.setTitle();
        this.setCurrentUrl();
        this.isOrganisationsLoaded = true;        
      }
      ));
    }

    /**return this.navigationService.getNavigationItem(this.id);
      })).subscribe(navigationItem => {
        this.educationType = navigationItem; */
    
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  setTitle() {
    if(this.period) {
      this.titleService.setTitle('Ristiinopiskelu' + environment.titleExtension) + '?period=' + this.period;
    } else {
      this.titleService.setTitle('Ristiinopiskelu' + environment.titleExtension);
    }
  }

  setCurrentUrl() {
    // asetetaan url
      if (!this.period) {
        this.globals.currentUrl = {
          valueFi: '/fi/' +  'ristiinopiskelu/' + this.id,
          valueEn: '/en/' + 'cross-institutional-studies/' + this.id,
          valueSv: '/sv/' + 'cross-institutional-studies/' + this.id
        }
      } else {
        this.globals.currentUrl = {
          valueFi: '/fi/' +  'ristiinopiskelu/' + this.id + '?period=' + this.period,
          valueEn: '/en/' + 'cross-institutional-studies/' + this.id + '?period=' + this.period,
          valueSv: '/sv/' + 'cross-institutional-studies/'+ this.id + '?period=' + this.period
        }
      }      
      this.globals.createLinkForCanonicalURL(); 
  }

  getOrganisations() {
    this.service.getOrganisations().pipe().subscribe(data => {
      this.organisations = data;
    });
  }

  getNetworks(id:any) {
    this.subscription.add(this.service.getCrossStudyNetworks(id).pipe().subscribe(data => {
      this.networks = data;
      this.globals.sortByName2(this.networks, this.globals.lang);
      this.networks.forEach(network => {
        this.globals.sortByName2(network.courses, this.globals.lang);
      });
      //this.isLoaded = true;
      this.isOrganisationsLoaded = true;
    }));
  }

 /* getNetworksAndOrganisations() {
    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        period: params[1].get('period')
      })),
      mergeMap(params => {
        this.period = params.period;
        return this.service.getOrganisations();
      }),
      mergeMap(organisations => {
          this.organisations = this.globals.sortMapValuesByName(organisations, this.globals.lang);
          //const sorted = this.globals.sortMapValuesByName(organisations, this.globals.lang);
          //this.organisations =
          return this.service.getCrossStudyNetworks('0');
      })).subscribe(networks => {
        this.networks = networks;
        this.setTitle();
        this.setCurrentUrl();
        this.isLoaded = true;
      }
      ));
  }*/
  /*getCourses(id:any) {
    this.service.getCoursesByCrossStudyNetworks(id).pipe().subscribe(data => {
      this.courses = data;
      
    });
  }*/

  collapse(event: any, j:any) {
    if (event.key === "Enter") {
      //event.stopPropagation();
      this.actions.emit({action:"collapsible", params:['open', j]}); 
     // this.actions2.emit({action:"collapsible", params:['open', j]}); 
    }
  }

  onOrganisationSelect(event: any){
    //console.log(event.source.value);
    this.isOrganisationsLoaded = false;
    /*if(event.source.value) {
      this.getNetworks(event.source.value);
    } else {
      this.getNetworks(0);
    }*/
    this.getNetworks(event.source.value);
  }

}

